import React from "react"
import ToggleContainer from "./ToggleContainer.styled"
import MoonIcon from "../../assets/icons/moon.svg"
import SunIcon from "../../assets/icons/sun.svg"

export default function Toggle({ theme, toggleTheme }: { theme: string; toggleTheme: () => void }): JSX.Element {
    const isLight = theme === "light"
    return (
        <ToggleContainer lightTheme={isLight} onClick={toggleTheme}>
            <img src={SunIcon} alt="sun" />
            <img src={MoonIcon} alt="moon" />
        </ToggleContainer>
    )
}
